export default {
      id: "stop.sprite-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#stop.sprite-usage",
      toString: function () {
        return this.url;
      }
    }